import React, { useEffect, useState } from "react";
import "./AboutUs.css";
import banner from "../Images/about-banner.jpeg"; // Replace with your actual banner image
import venuImg from "../Images/venu-kumar.webp"; // Replace with Dr. Venu Kumar Chukkala’s image
import Navbar from "../Home/Navbar";
import Footer from "../Home/Footer";

const AboutUs = () => {

    const [bannerImage, setBannerImage] = useState(""); // Store banner image URL

  useEffect(() => {
    // Fetch banner data from API
    fetch("https://api.garudasena.org/api/banners")
      .then((response) => response.json())
      .then((data) => {
        // Find the banner for the "About Us" section
        const aboutUsBanner = data.find((banner) => banner.section === "About Us");
        if (aboutUsBanner) {
          setBannerImage(aboutUsBanner.image); // Set the banner image URL
        }
      })
      .catch((error) => console.error("Error fetching banner data:", error));
  }, []);


  return (
    <> 
      <Navbar />
    <div className="about-page">
      {/* 🏞️ Banner Section */}

          <section className="about-banner">
            <img src={bannerImage} alt="About SASCCT" className="banner-image" />
          </section>
       

      {/* 📖 About Trust Section */}
      <section className="about-content container">
        <h2>About the Trust</h2>
        <p>
          The <strong>Ashtothara Shatha (108) Chukkala’s Charitable Trust</strong> is one such noble and novel
          initiative working towards minimizing social disparities, uplifting the needy, and expanding the
          horizons of <strong>Bhakthi</strong> as a movement for humanity. The trust’s primary mission is
          <em> facilitating an all-costs-borne maiden Tirumala trip and His Divine Darshan for Below Poverty Line devotees</em>.
        </p>

        <p>
          From times immemorial, pilgrimage has been considered an expensive affair—demanding time, money, and opportunity.
          In India, where spirituality and devotion are deeply rooted, every devotee dreams of visiting holy places to
          seek solace in divine presence.
        </p>

        <p>
          Among such sacred places, <strong>Tirupathi</strong>—the abode of <strong>Lord Sri Venkateshwara</strong>—is
          one of the most revered. To make this divine experience accessible to those unable to afford it,
          <strong> Dr. Venu Kumar Chukkala</strong>, an ardent devotee of Sri Balaji from Malakajgiri, initiated a
          unique spiritual movement providing free transportation, lodging, and boarding to devotees for a blessed Tirumala
          Darshan.
        </p>

        <p>
          With his unwavering devotion, Dr. Venu Kumar Chukkala completed <strong>108 Tirumala pilgrimages</strong> and
          continues his mission toward <strong>1008</strong> visits. With the blessings of revered spiritual leaders like
          <strong> Dr. K.V. Ramana Chari</strong> (Ex. EO, TTD), <strong>Shri Daivagna Sharma</strong>, and
          <strong> Sri Dr. A.V. Ramana Dikshitulu Swamy</strong>, the Trust was formally established.
        </p>

        <p>
          On <strong>September 13, 2014</strong>, his 39th birthday, Dr. Venu Kumar led 39 devotees to Tirumala,
          bearing all their expenses. This divine journey was inaugurated by <strong>Shri Daivagna Sharma</strong>.
          Since then, numerous groups of devotees have experienced the divine grace of Lord Venkateshwara
          through this initiative.
        </p>
      </section>

      {/* 🙏 About Founder Section */}
      <section className="founder-section">
        <div className="container founder-grid">
          <div className="founder-text">
            <h2>About Dr. Venu Kumar Chukkala</h2>
            <p style={{color:'#fff'}}>
              The miraculous story behind this initiative dates back to <strong>1996</strong>, when
              <strong> Dr. Venu Kumar Chukkala</strong> experienced the divine presence of Lord Sri Venkateshwara in a
              dream. Moved by this powerful vision, he embarked on his first <em>padayatra</em> (journey on foot) to Tirumala.
            </p>

            <p style={{color:'#fff'}}>
              His spiritual expeditions inspired him to walk to Tirumala <strong>9 consecutive times</strong>,
              each filled with deep devotion. Inspired by the late President of India,
              <strong> Dr. Shankar Dayal Sharma</strong>, who climbed the seven hills 108 times,
              Dr. Venu Kumar began his own <strong>“Ashtothara Shatha (108)”</strong> yatra — a vow he continues to fulfill.
            </p>
          </div>

          <div className="founder-image">
            <img src={venuImg} alt="Dr. Venu Kumar Chukkala" />
          </div>
        </div>
      </section>

      {/* 🎯 Vision & Mission */}
      <section className="vision-mission container">
        <div className="vision">
          <h2>Our Vision</h2>
          <p>
            To offer a true spiritual experience of Tirumala Yatra — free of cost — to all differently abled
            and below poverty line devotees who have not yet visited Tirumala.
          </p>
        </div>

        <div className="vision">
          <h2>Our Mission</h2>
          <p>
            To ensure all financially poor devotees of Lord Venkateshwara Swamy experience His divine grace
            at least once in their lifetime.
          </p>
        </div>
      </section>
    </div>

      <Footer/>
      </>
  );
};

export default AboutUs;
